import { render, staticRenderFns } from "./AddMultipleMedia.vue?vue&type=template&id=57553da6&scoped=true&"
import script from "./AddMultipleMedia.vue?vue&type=script&lang=js&"
export * from "./AddMultipleMedia.vue?vue&type=script&lang=js&"
import style0 from "./AddMultipleMedia.vue?vue&type=style&index=0&id=57553da6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57553da6",
  null
  
)

export default component.exports